import { style } from './map-styles.js';

const mapID = 'map'
const mapCenter = { lat: 50.929497, lng: 6.932983 }

function initMap() {
  const mapContainer = document.getElementById(mapID)
  const locations = JSON.parse(mapContainer.dataset.locations)

  const svg = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="#D93382" d="M12 0c-4.198 0-8 3.403-8 7.602 0 4.198 3.469 9.21 8 16.398 4.531-7.188 8-12.2 8-16.398 0-4.199-3.801-7.602-8-7.602zm0 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"/></svg>'

  const map = new google.maps.Map(mapContainer, {
    styles: style,
    center: mapCenter,
    zoom: 5,
    disableDefaultUI: true
  });

  locations.forEach((loc) => {
    const marker = new google.maps.Marker({
      position: { lat: parseFloat(loc.lat), lng: parseFloat(loc.lon) },
      map: map,
      locationID: loc.id,
      icon: {
        url: 'data:image/svg+xml;charset=UTF-8;base64,' + btoa(svg),
        size: new google.maps.Size(48, 48),
        scaledSize: new google.maps.Size(48, 48),
        anchor: new google.maps.Point(24, 48)
      }
    });

    const backdrop = document.getElementById('map-modals')
    const modal = document.getElementById("location-" + loc.id)

    marker.addListener('click', () => {
      backdrop.classList.add('active')
      modal.classList.add('active')
    })

    modal.querySelector('.map-location__header-close')
         .addEventListener('click', () => {
           closePopup()
         })

  })

  document.addEventListener("keydown", function(event) {
    const key = event.key;
    if (key === "Escape") {
      if (document.querySelector('.map-modals.active')) {
        closePopup()
      }
    }
  });
}

function closePopup() {
  document.querySelector('.map-modals.active').classList.remove('active')
  document.querySelector('.map-location.active').classList.remove('active')
}

function checkMap(id) {
  setTimeout(() => {
    const el = document.getElementById(id)
    const iframe = el.querySelector('iframe')
    if (iframe == null) {
      const note = document.createElement('p')
      note.appendChild(document.createTextNode("If you're using IE browser and can't see the map, please try to refresh this page. It is recommended to use modern browsers, please consider upgrading."))
      el.insertBefore(note, el.firstChild)
    }
  }, 10000);
}

window.initMap = initMap
document.addEventListener('turbolinks:load', function() {
  checkMap(mapID)
});

